import { action,  observable, toJS } from 'mobx';
import GlobalStore from '@/store/GlobalStore';
import ResultStore from '@/store/ResultStore'
import {getPriceList, cloudDevice} from '@/services/package';
import { orderInfo } from '@/services/orderCenter';
import router from '@/router';
import log from '@/utils/log';
import wx from 'weixin-js-sdk'

class PackageStore {

  @observable toast = GlobalStore.toast

  // 是否进入过后台进程
  @observable documentHidden = false

  // 支付url
  @observable payUrl = ''

  // 订单id
  @observable orderId

  // 订单状态
  @observable orderStatus = 0


  @observable userItemId

  // 设备类型 1：云手机Gvip；2：云挂机Vip；3: 基础设备2+8
  @observable deviceType = 2

  // 价格类型 1：购买；2：续费
  @observable priceType = 1

  // 当前选择的资费项数据
  @observable activeData: any = window.localStorage.getItem('activeData') ? JSON.parse(window.localStorage.getItem('activeData') || '') : {}

  // 超级套餐
  @observable packageTopList = []

  // 其他套餐
  @observable packageNormalList = []


  @action.bound setUserItemId (userItemId: any) {
    this.userItemId = userItemId
    this.priceType =  2
  }

  @action.bound async routerPushConfirmOrder () {
    if (Object.keys(this.activeData).length === 0) {
      this.toast.text('请选择资费项！')
      return false
    }
    if (this.activeData.price === 0) {
      await this.cloudDevice(true)
      return false
    }
    console.log(this.setUserItemId);
    const path = this.userItemId ? `confirmOrder?id=${this.userItemId}` : `confirmOrder`
    router.push({path: path})
  }

  // 获取资费列表
  @action.bound async getPriceList (params: any) {
    if(!params) {
      this.priceType = 1
    }
    params = params || {}
    if (Object.keys(params).length !== 0) {
      this.priceType = 2;
      this.deviceType = params.category
    }
    const response = await getPriceList({device_type: this.deviceType, price_type: this.priceType });

    if (response.code === 10000 ) {
      this.packageTopList = this.apiDataToStore(response.result.top_list);
      this.packageNormalList = this.apiDataToStore(response.result.normal_list);
    }

  }

  // 获取支付url
  @action.bound async cloudDevice (isFree: boolean) {
    const loading = this.toast.loading();
    const isWeixinCent = sessionStorage.getItem('isWeixinCent') // 是否是微信环境
    let params: any = {
      userItemId:this.userItemId,
      itemId: this.activeData.itemId,
      payType: isWeixinCent == 'true' ? 12 : 1,
      type: this.priceType,
      priceId: this.activeData.id ,
      channel: GlobalStore.channel,
      returnUrl:`${window.location.origin}/result`,
    }
    // 判读是否有openId
    const openId = sessionStorage.getItem('openId')
    if(openId) {
      params.openId = openId
    }
    if (this.activeData.price === 0) {
      params.payType = 0
    }

    const response = await cloudDevice(params);
    loading.hide()
    if (response && response.code === 10000) {
      if (response.result.code) {
        this.toast.text(response.result.msg)
        return
      }
      this.payUrl = response.result.request_url
      this.orderId = response.result.order_id
      window.localStorage.setItem('orderId', this.orderId)
      if (isFree ) {
        
        router.push({ path: 'result' })
      } else {
        console.log('dasdasdsd')
        if (isWeixinCent == 'true') {
          // 调取微信支付
          const wx_sdk = response.result.wx_sdk || {}
          wx.chooseWXPay({
            timestamp: wx_sdk.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: wx_sdk.nonceStr, // 支付签名随机串，不长于 32 位
            package: wx_sdk.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: wx_sdk.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: wx_sdk.paySign, // 支付签名
            success: function (res) {
              // 支付成功后的回调函数
              router.push({ path: 'result' })
            },
            fail: function (err) {
              console.log(err)
            }
          })
        } else {
          // 支付宝支付
          window.location.href = response.result.request_url
        }
      }
      return false
    }
    this.toast.text(response.msg)
  }

  // 接口数据转为组件数据
  @action.bound apiDataToStore (list: any) {
    return list.map(r => ({
      title: r.title,
      subtitle: r.subtitle,
      officialPrice: r.official_price,
      price: r.price,
      priceType: r.priceType,
      phoneType: r.phone_type,
      itemId: r.item_id,
      button: r.button,
      subscriptName: r.subscript_name,
      id: r.id
    }))
  }


  @action.bound onChangeSelection (activeData: object) {
    this.activeData = activeData
    window.localStorage.setItem('activeData', JSON.stringify(activeData))
  }

  // 滑动vip选项
  @action.bound async slidingSwiper (index: number) {
    console.log(index);
    this.activeData = {}
    window.localStorage.removeItem('activeData')
    const deviceTypeArray = [0,2,1,3] // （1：云手机；2：云挂机；3: 基础设备）
    this.deviceType = deviceTypeArray[String(index)]
    const packageInfo = window.localStorage.getItem('packageInfo')
    console.log(packageInfo);
    await this.getPriceList( packageInfo ? JSON.parse(packageInfo) :
      null)
    }

  @action.bound visibilitychange (documentHidden: boolean) {
    this.documentHidden = documentHidden;
  }

  @action.bound setPayUrl (payUrl: string) {
    this.payUrl = payUrl
  }

  // 查询订单状态
  @action.bound async getOrderInfo (orderId: any) {
    if (!this.orderId && !orderId) return
    const getOrderInfoTime = setInterval(async () => {
      const response = await orderInfo({orderId: this.orderId || orderId})
      if (response.code === 10000) {
        if (response.result.status === 2) {
          await log.logRequest({eventId: 'N1060',failReason: response.msg, trackId: orderId })
          ResultStore.initResultStore()
          clearInterval(getOrderInfoTime)
          clearTimeout(errorTime)
          this.orderStatus = response.result.status
          this.orderId = ''
        }
      }
    }, 1000)
    let errorTime = setTimeout(async () => {
      await log.logRequest({eventId: 'N1061', trackId: orderId})
      clearInterval(getOrderInfoTime)
      this.orderId = ''
      this.orderStatus = 3
      //this.toast.text('未支付完成,或还没收到付款，可以到订单中心查看')
    }, 60000)

  }

  //

  @action.bound resultStoreInit () {
    this.orderId = ''
    this.orderStatus = 0
  }

}

export default new PackageStore();
